"use client";

import { useSyncExternalStore } from "react";

type ChatUiState = {
  isOpen: boolean;
};

let state: ChatUiState = {
  isOpen: false,
};

const listeners = new Set<() => void>();

export function getChatUiState() {
  return state;
}

export function setChatUiOpen(isOpen: boolean) {
  if (state.isOpen === isOpen) return;
  state = { ...state, isOpen };
  listeners.forEach((listener) => listener());
}

export function toggleChatUi() {
  setChatUiOpen(!state.isOpen);
}

export function useChatUi() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    getChatUiState,
    () => ({ isOpen: false }),
  );
}
